import { render } from "./EodPanelCMS.vue?vue&type=template&id=2ca541b8"
import script from "./EodPanelCMS.vue?vue&type=script&lang=js"
export * from "./EodPanelCMS.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__